import PropTypes from 'prop-types'
import TruncatedString from '../TruncatedString/TruncatedString'
import classes from './User.module.scss'

const User = ({
  label,
  limit
}) =>
  <span className={classes.User}>
    <span
      aria-hidden // Hide from screen readers
      style={{ userSelect: 'none' }} // Can't select this dot
    >
      &#11044;
    </span>
    {' '}
    <TruncatedString
      limit={limit}
      value={label || ''}
    />
  </span>

User.propTypes = {
  label: PropTypes.string.isRequired,
  limit: PropTypes.number.isRequired
}

export default User
